import { render, staticRenderFns } from "./user-address.vue?vue&type=template&id=b3c77cd6&scoped=true&"
import script from "./user-address.vue?vue&type=script&lang=js&"
export * from "./user-address.vue?vue&type=script&lang=js&"
import style0 from "./user-address.vue?vue&type=style&index=0&id=b3c77cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c77cd6",
  null
  
)

export default component.exports